RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Alerts = RivalIQ.views.CollectionView.mixin({
        childView: views.Alert,
        emptyView: views.Empty,
        tagName: 'div',
        childEvents: {
            'error': 'onError'
        },
        dashboardModelEvents: {
            'change': 'reload'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            // NOTE - We need to set the companySetDescriptor to null (RivalIQ.state.companySets.none) in props when fetching the company data presences for alerts.
            // This is because "landscape" alerts - i.e. alerts that impact the entire landscape -
            // can be present from companies that are NOT the one selected in the companySetDescriptor.
            // We need the company data to be available for rendering the landscape alert details.

            const companyDataProps = _.defaults({
                companySetDescriptor: RivalIQ.state.companySets.none
            }, props);

            return $.when(
                RivalIQ.data.companyData.fetchPresences(companyDataProps),
                RivalIQ.data.alerts.fetch(props)
            ).then(function (companyData, alerts) {
                me.collection = alerts;
                me.companyData = companyData;
            });
        },

        onError: function (childView, model) {
            const me = this;
            me.collection.remove(model);
        },

        getChildView: function (model) {

            const type = model.get('event_type_id');
            return App.views.Alert.getViewClassFromType(type);
        },

        childViewOptions: function () {

            const me = this;
            return _.pick(me, 'companyData', 'dashboardModel');
        },

        filter: function (child) {

            const me = this;

            const eventDisplay = RivalIQ.utils.eventDisplay;
            if (eventDisplay.hasMetric(child.get('event_type_id')) &&
                !RivalIQ.models.MetricDefinition.exists(child.get('data'))) {
                return false;
            }

            const companyId = child.get('company_id');
            return Boolean(me.companyData && me.companyData.get(companyId));
        }
    });
});
